import { GET_AGE_GATE_CONFIG } from "../../constants/ageGateConfig";
import * as feeds from "../../apis/services/feeds";

export const getAgeGateConfig = () => ({
  type: GET_AGE_GATE_CONFIG,
  payload: feeds.getAgeGateConfig(),
});
